/**
 * @spec /doc/specs/frontend/design-system/mockups/index.html
 * @userStory S2-LANDING
 *
 * Navigation utilities for internationalized routing using next-intl.
 * Provides Link, redirect, usePathname, and useRouter with locale support.
 */

import { createNavigation } from 'next-intl/navigation';
import { routing } from './routing';

export const { Link, redirect, usePathname, useRouter } = createNavigation(routing);
